(function() { window.GUID_1919b7f8_81ff_498b_afff_66a2ca8cc2f0 = { getGuid: function() { return "1919b7f8-81ff-498b-afff-66a2ca8cc2f0"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let FilterType;
        (function (FilterType) {
            FilterType[FilterType["Associations"] = 1] = "Associations";
            FilterType[FilterType["Operators"] = 2] = "Operators";
            FilterType[FilterType["Events"] = 3] = "Events";
            FilterType[FilterType["HomeBar"] = 4] = "HomeBar";
            FilterType[FilterType["Divisions"] = 5] = "Divisions";
            FilterType[FilterType["EntityType"] = 6] = "EntityType";
            FilterType[FilterType["PlayerType"] = 7] = "PlayerType";
            FilterType[FilterType["CSR"] = 8] = "CSR";
            FilterType[FilterType["Name"] = 9] = "Name";
            FilterType[FilterType["Date"] = 10] = "Date";
            FilterType[FilterType["OnlyMyResults"] = 11] = "OnlyMyResults";
            FilterType[FilterType["OnlyFinishedResults"] = 12] = "OnlyFinishedResults";
            FilterType[FilterType["OnlyUnfinishedResults"] = 13] = "OnlyUnfinishedResults";
            FilterType[FilterType["OnlyEntitiesResults"] = 14] = "OnlyEntitiesResults";
            FilterType[FilterType["Preset"] = 15] = "Preset";
            FilterType[FilterType["AdrState"] = 16] = "AdrState";
            FilterType[FilterType["Sport"] = 17] = "Sport";
            FilterType[FilterType["Feat"] = 18] = "Feat";
            FilterType[FilterType["WinsOrLosses"] = 19] = "WinsOrLosses";
            FilterType[FilterType["GameFormat"] = 20] = "GameFormat";
            FilterType[FilterType["DateRange"] = 21] = "DateRange";
            FilterType[FilterType["EventType"] = 22] = "EventType";
            FilterType[FilterType["OnlyResultsWithVideos"] = 23] = "OnlyResultsWithVideos";
            FilterType[FilterType["TimePeriod"] = 24] = "TimePeriod";
            FilterType[FilterType["Year"] = 25] = "Year";
            FilterType[FilterType["Distance"] = 26] = "Distance";
            FilterType[FilterType["City"] = 27] = "City";
            FilterType[FilterType["Address"] = 28] = "Address";
            FilterType[FilterType["OnlyFavoriteResults"] = 29] = "OnlyFavoriteResults";
            FilterType[FilterType["OnlyForCSRDetail"] = 30] = "OnlyForCSRDetail";
            FilterType[FilterType["Opponents"] = 31] = "Opponents";
            FilterType[FilterType["OnlyMyOpponents"] = 32] = "OnlyMyOpponents";
            FilterType[FilterType["Layout"] = 33] = "Layout";
        })(FilterType = Enumeration.FilterType || (Enumeration.FilterType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=FilterType.pre.js.map
